import React, { Component } from 'react'
import { BaseEntityPage } from '../BaseEntityPage';
import { ApiHelper } from '../../helpers/ApiHelper';
import { Helper } from '../../helpers/Helper';
import { AppHelper } from '../../../helpers/AppHelper';
import { css } from 'aphrodite';
import { AppStyles } from '../../../styles/AppTheme';
import { Link } from 'react-router-dom';
import Tooltip from '@material-ui/core/Tooltip';

export class Options extends BaseEntityPage {
  constructor(props) {
    super(props)
    this.pageTitle = 'Options'
    this.itemId = this.props.match.params.id;
    this.subId = this.props.match.params.subId;
    this.qId = this.props.match.params.qId;
    this.toFetch = [
      { method: 'GET', endPoint: ApiHelper.makeUrlPath(['questions', this.qId], { pb: 'fieldDefOptions'}) },
    ]
    this.tableHeaders = [
      'order',
      'option'
    ]
  }
  onTableValue(current, index) {
    switch (index) {
    case 0:
      return current.order
    case 1:
      return current.title
    default:
      return ''
    }
  }
  onFetchSuccess(results) {
    console.log('results:', results)
    this.formDefinition = results[0].fieldDef.fieldDefOptions
    const options = Helper.sortDictArray(Helper.dictToArray(results[0].options) || [])
    if (options.length === 2 && results[0].type === 'YESNO') {
      this.noAdd = true
    }
    this.setState({
      question: results[0],
      items: options
    })
  }
  onAdd() {
    this.setState({
      apiMethod: 'PUT',
      apiData: { entityAction: 'add', entityAttrName: 'options' },
      apiEndPoint: ApiHelper.makeUrlPath(['questions', this.qId]),
    });
  }
  onEdit(current) {
    this.setState({
      apiMethod: 'PUT',
      apiData: { entityAction: 'edit', entityAttrName: 'options', id: current.id },
      apiEndPoint: ApiHelper.makeUrlPath(['questions', this.qId]),
    });
  }
  onDelete(current) {
    this.setState({
      apiMethod: 'PUT',
      apiData: { entityAction: 'del', entityAttrName: 'options', id: current.id },
      apiEndPoint: ApiHelper.makeUrlPath(['questions', this.qId]),
    });
  }
  onActions = (current) => {
    const actions = []
    actions.push(AppHelper.buttonEdit(this, current))
    // actions.push(AppHelper.buttonDelete(this, current))
    // actions.push(
    //   <Link to={'/admin/quiz/' + this.itemId + '/qssecs/' + this.subId + '/questions/' + this.qId + '/options/' + current.id + '/branch'} key={current.id + '-questions'}>
    //     <Tooltip title='Branch Questions' placement='top-start'>
    //       <span className={css(AppStyles.entityTableLinkIcon)}>
    //         <i className='material-icons'>question_answer</i>
    //       </span>
    //     </Tooltip>
    //   </Link>
    // )
    return actions
  }
}


// WEBPACK FOOTER //
// ./src/common/components/quizcreator/Options.js